<template>
  <section class="panel">
    <div class="toolbar">
      <el-input v-model="query.code" placeholder="防伪码" clearable style="width:180px" />
      <el-input v-model="query.productName" placeholder="产品名称" clearable style="width:180px" />
      <el-input v-model="query.userNickname" placeholder="用户昵称" clearable style="width:150px" />
      <el-input v-model="query.userPhone" placeholder="用户手机号" clearable style="width:150px" />
      <el-select v-model="query.scanStatus" placeholder="扫码状态" clearable style="width:130px">
        <el-option label="正常" value="NORMAL" />
        <el-option label="本人复核" value="SELF_RECHECK" />
        <el-option label="异常" value="ABNORMAL" />
      </el-select>
      <el-select v-model="query.seriesCategoryId" placeholder="系列分类" clearable style="width:140px">
        <el-option v-for="item in categories.SERIES" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>
      <el-select v-model="query.modelCategoryId" placeholder="型号分类" clearable style="width:140px">
        <el-option v-for="item in categories.MODEL" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>
      <el-select v-model="query.performanceCategoryId" placeholder="性能分类" clearable style="width:140px">
        <el-option v-for="item in categories.PERFORMANCE" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>
      <el-input v-model="query.batchNo" placeholder="批次号" clearable style="width:150px" />
      <el-button class="btn-search" icon="el-icon-search" @click="search">查询</el-button>
    </div>
    <el-table :data="page.records" border size="small">
      <el-table-column prop="pid" label="PID" width="80" />
      <el-table-column prop="code" label="防伪码" min-width="180" />
      <el-table-column prop="userNickname" label="用户昵称" width="140" />
      <el-table-column prop="userPhone" label="用户手机号" width="130" />
      <el-table-column prop="productName" label="产品名称" min-width="150" />
      <el-table-column prop="seriesCategoryName" label="系列分类" width="110" />
      <el-table-column prop="modelCategoryName" label="型号分类" width="110" />
      <el-table-column prop="performanceCategoryName" label="性能分类" width="110" />
      <el-table-column prop="batchNo" label="批次号" width="130" />
      <el-table-column prop="manufactureDate" label="生产日期" width="110" />
      <el-table-column prop="userLocation" label="用户位置" min-width="170" />
      <el-table-column label="扫码状态" width="100">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="scanStatusType(row.scanStatus)">
            {{ scanStatusText(row.scanStatus) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="scanTime" label="扫码时间" width="170" />
    </el-table>
    <el-pagination
      class="pager"
      background
      layout="total, sizes, prev, pager, next"
      :current-page="page.page"
      :page-size="page.size"
      :page-sizes="[10, 20, 50, 100]"
      :total="page.total"
      @size-change="size => { query.size = size; search() }"
      @current-change="p => { query.page = p; load() }"
    />

  </section>
</template>

<script>
import http from '../api'

const blankPage = { total: 0, page: 1, size: 10, records: [] }
const categoryTypes = ['SERIES', 'MODEL', 'PERFORMANCE']

export default {
  data() {
    return {
      query: { page: 1, size: 10 },
      page: { ...blankPage },
      categories: { SERIES: [], MODEL: [], PERFORMANCE: [] }
    }
  },
  mounted() {
    this.loadCategories()
    this.load()
  },
  methods: {
    async loadCategories() {
      for (const type of categoryTypes) {
        this.categories[type] = await http.get('/admin/categories', { params: { categoryType: type } })
      }
    },
    async load() {
      this.page = await http.get('/admin/scan-records', { params: this.query })
    },
    search() {
      this.query.page = 1
      this.load()
    },
    scanStatusText(status) {
      const map = { NORMAL: '正常', SELF_RECHECK: '本人复核', ABNORMAL: '异常' }
      return map[status] || status || '-'
    },
    scanStatusType(status) {
      if (status === 'NORMAL') return 'success'
      if (status === 'SELF_RECHECK') return 'warning'
      return 'danger'
    }
  }
}
</script>
